// src/App.js

import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import AssistantsPage from './components/AssistantsPage';
import AssistantChat from './components/AssistantChat';
import './App.css';
import { ChatBubbleFrontend } from './components/ChatBubbleFrontend';
import Register from './components/Register';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import SolicitarAcceso from './components/SolicitarAcceso';
import { ApiKeyProvider } from './context/ApiKeyContext';
import TemplatesPage from './components/Templates'; // Página ya existente
import ThreadsViewer from './components/ThreadsViewer';
import Header from './components/Header'; 
import Sidebar from './components/Sidebar';
import WideSidebar from './components/WideSidebar';
import { ThemeProvider, ThemeContext } from './context/ThemeContext';
import MisAsistentes from './components/MisAsistentes';
import backgroundApp from './assets/background-app.webp'; 
import PrivacyPolicy from './PrivacyPolicy';
import ServiceConditions from './ServiceConditions';
import { AssistantProvider } from './context/AssistantContext'; 
import { SelectedAgentProvider } from './context/SelectedAgentContext';
import CompleteSignUp from './components/CompleteSignUp';
import ComingSoon from './components/ComingSoon';
import Profile from './components/Profile';
import Analytics from './components/Analytics';
import Support from './components/Support';
import { SubscriptionProvider } from './context/SubscriptionContext';
import SubscriptionExpiredModal from './components/SubscriptionExpiredModal';
import ResetPassword from './components/ResetPassword';
import HandleAction from './components/HandleAction';
import CRM from './components/CRM';
import { SearchProvider } from './context/SearchContext';
import { SelectedTeamMemberProvider } from './context/SelectedTeamMemberContext';
import MobileHeader from './components/HeaderMobile';
import SubscriptionAlert from './components/SubscriptionAlert';
import Subscription from './components/Subscription';
import Checkout from './components/Checkout';
import MercadoPagoDemo from './components/MercadoPagoDemo';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AppContent() {
  const { isLightMode } = useContext(ThemeContext);
  const location = useLocation();

  const [showSubscriptionAlert, setShowSubscriptionAlert] = useState(true);
    // nuevo estado: indica si está "efectivamente" activa en DOM
// Nuevo estado para indicar si la alerta está REALMENTE activa o no.
const [alertActuallyActive, setAlertActuallyActive] = useState(false);

// Callback que se pasa al componente hijo:
const handleAlertActiveChange = (active) => {
  setAlertActuallyActive(active);
};
  const [isWideSidebarVisible, setWideSidebarVisible] = useState(true);
  
  // Identificar páginas de autenticación:
  const isAuthPage = ['/login', '/reset-password', '/handle-action'].includes(location.pathname);
  const isAgentPage = location.pathname.startsWith('/chat')  ;
  const isProfilePage = location.pathname.startsWith('/profile') ;

  

 // Definimos las alturas fijas (en px)
 const headerHeight = 60;
 const alertHeight = 60; // Debe coincidir con la altura definida en SubscriptionAlert.css

 // El contenedor de rutas se empuja hacia abajo si el alert está visible.
 const contentMarginTop = headerHeight + (alertActuallyActive ? alertHeight : 0);


 // La WideSidebar siempre se posiciona a 60px (headerHeight) desde arriba.
 const wideSidebarTopOffset = headerHeight;

 // Para que el alert no cubra la WideSidebar, calculamos su left offset:
 const subscriptionAlertLeftOffset =
   !isAuthPage && window.innerWidth > 1000 && isWideSidebarVisible && !isProfilePage
     ? "calc(60px + 18em)" // 60px (offset inicial de la sidebar) + 18em (ancho de la sidebar)
     : "0";


  // Identificar si es página de mensajes/chat para ajustar padding:
  const isThreadsPage = location.pathname.startsWith('/messages') 
    || location.pathname.startsWith('/chat/') 
    || location.pathname.startsWith('/crm') 
    || location.pathname === '/support';


      // Estados para detección de ventanas
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    // Limpieza al desmontar
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  const toggleWideSidebar = () => {
    if (!isAuthPage) {
      setWideSidebarVisible(!isWideSidebarVisible);
    }
  };

  let appClassName = 'App';
  let appStyle = {};

  // Aplicar estilo login-register si es página auth:
  if (isAuthPage) {
    appClassName += ' login-register';
    appStyle = {
      backgroundImage: `url(${backgroundApp})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: 'var(--vph)',
    };
  }   if (isAgentPage) {
    appStyle = {
      backgroundImage: `none`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundColor:'#020321', 
      minHeight: 'var(--vph)',
    };
  } else {
    appStyle = {
      background: 'radial-gradient(ellipse at 0% 0%, rgba(140, 50, 220, 0.35) 0%, transparent 50%), radial-gradient(ellipse at 100% 100%, rgba(100, 30, 180, 0.25) 0%, transparent 50%), linear-gradient(180deg, #0a0a1a 0%, #050510 100%)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: 'var(--vph)',
    };
  }

  const contentContainerClass = `
  ${isThreadsPage ? 'content-container no-padding' : 'content-container'} 
  ${isWideSidebarVisible && windowWidth >= 1000 && !isProfilePage ? 'wide-sidebar-visible' : ''} 
  ${isAgentPage ? 'is-agent-page' : ''}
  ${isProfilePage ? 'is-profile-page' : ''}
`.trim();



  return (
    <div className={`${appClassName} the-thing-global-text-style`} style={appStyle}>

<SearchProvider>
<SelectedTeamMemberProvider>
      <AssistantProvider>
        <SelectedAgentProvider>
          <AuthProvider>
            <ApiKeyProvider>
              <SubscriptionExpiredModal />
         {/* Para móviles */}
         {!isAuthPage && windowWidth <= 1000 && (
                    <>
                      <MobileHeader />
                      <SubscriptionAlert 
                        visible={showSubscriptionAlert} 
                        onClose={() => setShowSubscriptionAlert(false)}
                        alertStyle={{ left: "0" }} // full width en móviles
                        onActiveChange={handleAlertActiveChange} // Importante
                      />
                    </>
                  )}

                  {/* Para escritorio */}
                  {!isAuthPage && windowWidth > 1000 && (
                    <>
                      <Header 
                        toggleWideSidebar={toggleWideSidebar}
                        isWideSidebarVisible={isWideSidebarVisible}
                      />
<SubscriptionAlert 
  visible={showSubscriptionAlert} 
  onClose={() => setShowSubscriptionAlert(false)}
  alertStyle={{ left: subscriptionAlertLeftOffset }}
  onActiveChange={handleAlertActiveChange} // Importante
/>

                    </>
                  )}

                  {/* Sidebar y WideSidebar */}
                  {!isAuthPage && windowWidth > 1000 && (
                    <>
                      <Sidebar />
                      {!isProfilePage && (
                        <WideSidebar 
                          isVisible={isWideSidebarVisible} 
                          topOffset={wideSidebarTopOffset} // Siempre a 60px
                        />
                      )}
                    </>
                  )}

              {isAuthPage ? (
                // Rutas de autenticación (sin content-container)
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/handle-action" element={<HandleAction />} />
                </Routes>
              ) : (
                // Rutas no auth (envueltas en content-container)
                <div className={contentContainerClass} style={{ marginTop: `${contentMarginTop}px` }}>

                  <Routes>
                    <Route path="/" element={<ProtectedRoute element={<MisAsistentes isWideSidebarVisible={isWideSidebarVisible} />} />} />
                    <Route path="/chat/:assistantId" element={<ProtectedRoute element={<AssistantChat />} />} />
                    <Route path="/bubble/" element={<ProtectedRoute element={<ChatBubbleFrontend />} />} />
                    <Route path="/bubble/:assistantId" element={<ProtectedRoute element={<ChatBubbleFrontend />} />} />
                    <Route path="/solicitar-acceso" element={<SolicitarAcceso />} />
                    <Route path="/templates" element={<ProtectedRoute element={<TemplatesPage />} />} />
<Route
  path="/messages"
  element={
    <ProtectedRoute
      element={
        <ThreadsViewer
          showSubscriptionAlert={showSubscriptionAlert}
          setShowSubscriptionAlert={setShowSubscriptionAlert}
        />
      }
    />
  }
/>
<Route
  path="/messages/:assistantId"
  element={
    <ProtectedRoute
      element={
        <ThreadsViewer
          key={location.pathname.split('/')[2]} // Extrae el assistantId de la URL
          showSubscriptionAlert={showSubscriptionAlert}
          setShowSubscriptionAlert={setShowSubscriptionAlert}
        />
      }
    />
  }
/>
<Route
  path="/messages/:assistantId/:threadId"
  element={
    <ProtectedRoute
      element={
        <ThreadsViewer
          key={location.pathname.split('/')[2]} // También usamos el assistantId como key
          showSubscriptionAlert={showSubscriptionAlert}
          setShowSubscriptionAlert={setShowSubscriptionAlert}
        />
      }
    />
  }
/>



                    <Route path="/crm" element={
                      <ProtectedRoute element={
                        <CRM isWideSidebarVisible={isWideSidebarVisible} />
                      } />
                    } />
                    <Route path="/profile" element={<ProtectedRoute element={<Profile />} />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/service-conditions" element={<ServiceConditions />} />
                    <Route path="/completesignup" element={<CompleteSignUp />} />
                    <Route path="/coming-soon" element={<ComingSoon />} />
                    <Route path="/analytics" element={<ProtectedRoute element={<Analytics />} />} />
                    <Route path="/support" element={<ProtectedRoute element={<Support />} />} />
                    <Route path="/subscription" element={<ProtectedRoute element={<Subscription />} />} />
                    <Route path="/checkout" element={<ProtectedRoute element={<Checkout />} />} />
                    <Route path="/checkout/mercadopago-demo" element={<ProtectedRoute element={<MercadoPagoDemo />} />} />

                  </Routes>
                </div>
              )}
            </ApiKeyProvider>
          </AuthProvider>
        </SelectedAgentProvider>
      </AssistantProvider>
      </SelectedTeamMemberProvider>
      </SearchProvider>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AuthProvider>
          <SubscriptionProvider>
            <AppContent />
            <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        fontFamily="Outfit"
        closeOnClick
        draggable
      />
          </SubscriptionProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
    
  );
}

export default App;
